import { render, staticRenderFns } from "./EmailChange.vue?vue&type=template&id=775247e2"
import script from "./EmailChange.vue?vue&type=script&lang=ts"
export * from "./EmailChange.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports